<template>
  <layout
    title="Dashboard:: Cukai Petak"
    :crumbs="crumbs"
  >
  </layout>
</template>

<script>
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        crumbs: [
          { label: this.$page.props.app_name, route: '/sitemap' },
          { label: 'Cukai Petak', route: '/cukai-petak/dashboard' },
        ]
    }
  }
}
</script>